let messages = {
  index1: '日本語',
  index2: 'ログアウト',
  index3: 'ホーム',
  index4: 'アカウント情報',
  index5: '入金',
  index6: '出金',
  index7: '資金移動',
  index8: '財布',
  index9: '現金口座(MEQ)',
  index10: '代理情報',
  index11: 'サブエージェントの数',
  index12: 'ユーザーの数',
  index13: 'サブエージェントの追加',
  index14: '招待リンク',
  index15: 'リンクをコピー',
  index16: 'やることリスト',
  index17: '顧客資料の詳細',
  index18: '出金申請',
  index19: '入金申請',
  index20: 'マイプロフィール',
  index21: '氏名',
  index22: 'エージェントID',
  index23: '登録時刻',
  index24: '電子メール',
  index25: 'ログインパスワード',
  index26: '銀行情報',
  index27: '口座名義人',
  index28: '銀行名',
  index29: '銀行カードの口座番号',
  index30: 'パスワードリセット',
  index31: '古いパスワードを入力してください',
  index32: '新しいパスワードを入力してください',
  index33: '提出する',
  index34: '銀行カード情報の変更',
  index35: '通知',
  index36: '資金移動が成功しました',
  index37: '入金成功',
  index38: '出金成功',
  my1: '日本語',
  my2: 'ログアウト',
  my3: '資金管理',
  my4: '入金',
  my5: '入金報告',
  my6: '入金タイプ',
  my7: '現金入金',
  my8: '現金口座',
  my9: '$',
  my10: '入金額',
  my11: 'USDT / MEQ 為替レート',
  my12: '入金額',
  my13: '入金受領書',
  my14: '入金額を入力してください',
  my15: 'Please enter the Transaction Hash',
  my16: '財布(MEQ)',
  my17: '振替出金額',
  my18: '送金銀行',
  my19: '口座名義人',
  my20: '銀行名',
  my21: '銀行カードの口座番号',
  my22: '提出する',
  my23: '入金注文が正常に送信されました',
  my24: 'ご注文は1～2営業日以内に審査および処理されます',
  my25: '確認する',
  my26: '資金移動が成功しました',
  my27: '資金移動',
  my28: '資金移動報告',
  my29: '受取人',
  my30: '代理',
  my31: 'ユーザー',
  my32: '受取人ID',
  my33: '受取人IDを入力してください',
  my34: 'ユーザーID',
  my35: 'ユーザーIDを入力してください',
  my36: '受取人ユーザー名',
  my37: '現金口座(MEQ)',
  my38: '$',
  my39: '資金移動金額',
  my40: '資金移動の金額を入力してください',
  my41: '提出する',
  my42: '資金移動成功',
  my43: '確認する',
  my44: '出金',
  my45: '出金記録',
  my46: '現金口座残高',
  my47: '$',
  my48: '出金額',
  my49: '引き出し金額を入力してください',
  my50: '為替レート',
  my51: '出金額',
  my52: '受取銀行',
  my53: '出金申請が正常に提出されました',
  my54: '注文は1〜2営業日以内に審査および処理されます',
  my55: '確認する',
  my56: 'リマインダー',
  my57: 'まだ銀行カード情報が確認されていません。出金前に銀行カード情報を完了してください。',
  my58: 'キャンセル',
  my59: '即時完了',
  my60: '提出する',
  my61: '財布(MEQ)',
  my62: '送金額(MEQ)',
  my63: '転出金額を入力してください',
  my64: 'ウォレット残高を現金口座に振り込む',
  my65: '提出する',
  my66: '注文番号',
  my67: 'ウォレット残高(MEQ)',
  my68: '資金移動金額(MEQ)',
  my69: '現金口座',
  my70: '資金移動時間',
  my71: '説明',
  my72: '手数料収入',
  my73: '現金口座への振り込み',
  my74: '合計 x 件',
  my75: 'x 件/ページ',
  my76: '資金移動が成功しました',
  my77: '確認する',
  my78: '入金報告',
  my79: 'ステータス',
  my80: 'すべて',
  my81: '審査待ち',
  my82: '審査通過',
  my83: '審査不合格',
  my84: '入金時間',
  my85: '検索',
  my86: '注文番号',
  my87: '入金額(MEQ)(MEQ)',
  my201: '入金額(MEQ)',
  my88: '入金額(USDT)',
  my89: '為替レート',
  my90: '現金口座残高',
  my91: '入金時間',
  my92: '入金受領書',
  my93: '入金番号',
  my94: '審査備考',
  my95: 'ステータス',
  my96: '操作する',
  my97: '詳細',
  my98: '閉じる',
  my99: '合計 x 件',
  my100: '{n} 件/ページ',
  my101: 'x ページに移動',
  my102: '出金報告',
  my103: 'ステータス',
  my104: 'すべて',
  my105: '審査待ち',
  my106: '審査通過',
  my107: '審査不合格',
  my108: '出金時間',
  my109: '検索',
  my110: '注文番号',
  my111: '出金額(USDT)',
  my112: '出金額',
  my113: '為替レート',
  my114: '現金口座残高',
  my115: '出金時間',
  my116: '備考',
  my117: 'ステータス',
  my118: '操作する',
  my119: '詳細',
  my120: '閉じる',
  my121: '合計 x 件',
  my122: '{n} 件/ページ',
  my123: 'x ページに移動',
  my124: '資金移動報告',
  my125: '受取人',
  my126: 'すべて',
  my127: '代理',
  my128: 'ユーザー',
  my129: '資金移動の種類',
  my130: 'すべて',
  my131: '振替入金',
  my132: '振替出金',
  my133: '受取人ID',
  my134: '受取人IDを入力してください',
  my135: '資金移動時間',
  my136: '検索',
  my137: 'エクスポート',
  my138: '注文番号',
  my139: '受取人',
  my140: '受取人ID',
  my141: '資金移動金額(MEQ)',
  my142: '現金口座残高($)',
  my143: '資金移動の種類',
  my144: '資金移動時間',
  my145: '合計 x 件',
  my146: 'x 件/ページ',
  my147: 'x ページに移動',
  my148: '受取人ID',
  my149: '受取人の名前',
  my150: '受取人のIDを入力してください',
  my151: '受取人のIDを入力してください',
  my152: 'ユーザーIDを入力してください',
  my153: '代理ID / 上位代理ID',
  my154: '資金移動時間',
  my155: 'Tether(USDT)',
  my156: '入金額(MEQ)',
  my157: '備考',
  my401: '変動前残高(MEQ)',
  proxymoney1: '日本語',
  proxymoney2: 'ログアウト',
  proxymoney3: '資金審査',
  proxymoney4: '代理入金審査',
  proxymoney5: 'ステータス',
  proxymoney6: 'すべて',
  proxymoney7: '審査通過',
  proxymoney8: '審査不合格',
  proxymoney9: 'エージェントID',
  proxymoney10: '代理ID / 上位代理IDを入力してください',
  proxymoney11: '入金時間',
  proxymoney12: '検索',
  proxymoney13: 'エクスポート',
  proxymoney14: '注文番号',
  proxymoney15: '氏名',
  proxymoney16: 'エージェントID',
  proxymoney17: '上級エージェントID',
  proxymoney18: '入金額 ({n})',
  proxymoney19: '入金額',
  proxymoney20: '為替レート',
  proxymoney21: '現金口座残高',
  proxymoney22: '入金時間',
  proxymoney23: '入金受領書',
  proxymoney24: '備考',
  proxymoney25: 'ステータス',
  proxymoney26: '操作する',
  proxymoney27: '承認',
  proxymoney28: '詳細',
  proxymoney29: '合格',
  proxymoney30: '失敗',
  proxymoney31: '入金番号',
  proxymoney32: '承認の意見を入力してください',
  proxymoney33: 'ステータス',
  proxymoney34: '確認する',
  proxymoney35: 'キャンセル',
  proxymoney36: '合計 x 件',
  proxymoney37: 'x 件/ページ',
  proxymoney38: 'x ページに移動',
  proxymoney39: 'ステータス',
  proxymoney40: 'すべて',
  proxymoney41: '審査通過',
  proxymoney42: '審査不合格',
  proxymoney43: 'エージェントID',
  proxymoney44: '代理名を入力してください',
  proxymoney45: '出金時間',
  proxymoney46: '検索',
  proxymoney47: 'エクスポート',
  proxymoney48: '注文番号',
  proxymoney49: '氏名',
  proxymoney50: 'エージェントID',
  proxymoney51: '上級エージェントID',
  proxymoney52: '出金額({n})',
  proxymoney201: '出金額(USDT)',
  proxymoney53: '出金額(MEQ)',
  proxymoney54: '為替レート',
  proxymoney55: '現金口座残高',
  proxymoney56: '出金時間',
  proxymoney57: '備考',
  proxymoney58: 'ステータス',
  proxymoney59: '操作する',
  proxymoney60: '承認',
  proxymoney61: '詳細',
  proxymoney62: '銀行情報',
  proxymoney63: '口座開設者',
  proxymoney64: '銀行名',
  proxymoney65: '銀行カード番号',
  proxymoney66: '口座開設支店',
  proxymoney67: '合格',
  proxymoney68: '失敗',
  proxymoney69: 'キャンセル',
  proxymoney70: '確認する',
  proxymoney71: '承認の意見を入力してください',
  proxymoney72: '閉じる',
  proxymoney73: 'ステータス',
  proxymoney74: '合計 x 件',
  proxymoney75: 'x 件/ページ',
  proxymoney76: 'x ページに移動',
  proxymoney77: '顧客入金審査',
  proxymoney78: 'ステータス',
  proxymoney79: 'すべて',
  proxymoney80: '審査通過',
  proxymoney81: '審査不合格',
  proxymoney82: 'エージェントID',
  proxymoney83: '顧客ID / 上位代理IDを入力してください',
  proxymoney84: '入金時間',
  proxymoney85: '検索',
  proxymoney86: 'エクスポート',
  proxymoney87: '注文番号',
  proxymoney88: '氏名',
  proxymoney89: 'ユーザーID',
  proxymoney90: '上級エージェントID',
  proxymoney91: '入金額 ({n})',
  proxymoney92: '入金額($)',
  proxymoney93: '実際の入金($)',
  proxymoney94: '為替レート',
  proxymoney95: '現金口座残高',
  proxymoney96: '入金時間',
  proxymoney97: '入金受領書',
  proxymoney98: '入金番号',
  proxymoney99: '備考',
  proxymoney100: 'ステータス',
  proxymoney101: '操作する',
  proxymoney102: '承認',
  proxymoney103: '詳細',
  proxymoney104: 'キャンセル',
  proxymoney105: '確認する',
  proxymoney106: 'ステータス',
  proxymoney107: '閉じる',
  proxymoney108: '承認の意見を入力してください',
  proxymoney109: '確認する',
  proxymoney110: 'キャンセル',
  proxymoney111: '金額を入力してください',
  proxymoney112: '合計 x 件',
  proxymoney113: 'x 件/ページ',
  proxymoney114: 'x ページに移動',
  proxymoney115: '顧客出金審査',
  proxymoney116: 'ステータス',
  proxymoney117: 'すべて',
  proxymoney118: '審査通過',
  proxymoney119: '審査不合格',
  proxymoney120: 'エージェントID',
  proxymoney121: '顧客ID / 上位代理IDを入力してください',
  proxymoney122: '出金時間',
  proxymoney123: '検索',
  proxymoney124: 'エクスポート',
  proxymoney125: '注文番号',
  proxymoney126: '氏名',
  proxymoney127: 'ユーザーID',
  proxymoney128: '上級エージェントID',
  proxymoney129: '出金額',
  proxymoney130: '出金額($)',
  proxymoney131: '為替レート',
  proxymoney132: '出金時間',
  proxymoney133: '備考',
  proxymoney134: 'ステータス',
  proxymoney135: '操作する',
  proxymoney136: '承認',
  proxymoney137: '詳細',
  proxymoney138: '銀行情報',
  proxymoney139: '口座開設者',
  proxymoney140: '銀行名',
  proxymoney141: '銀行カードの口座番号',
  proxymoney142: '口座開設支店',
  proxymoney143: '合格',
  proxymoney144: '失敗',
  proxymoney145: 'キャンセル',
  proxymoney146: '確認する',
  proxymoney147: 'ご承認のご意見を入力してください',
  proxymoney148: '閉じる',
  proxymoney149: 'ステータス',
  proxymoney150: '合計 x 件',
  proxymoney151: 'x 件/ページ',
  proxymoney152: 'x ページに移動',
  proxyproxy1: '日本語',
  proxyproxy2: 'ログアウト',
  proxyproxy3: 'サブエージェント管理',
  proxyproxy4: 'サブエージェントリスト',
  proxyproxy5: '氏名/エージェントID',
  proxyproxy6: '名前またはエージェントIDを入力してください',
  proxyproxy7: '検索',
  proxyproxy8: 'エクスポート',
  proxyproxy9: '代理を作成する',
  proxyproxy10: '氏名',
  proxyproxy11: 'サブエージェントの名前を入力してください',
  proxyproxy12: '電子メール',
  proxyproxy13: 'メールアドレスを入力してください',
  proxyproxy14: 'ログインパスワード',
  proxyproxy15: '数字と英文字の組み合わせを使用し、8から16文字まで',
  proxyproxy16: '手数料率(手数料)',
  proxyproxy17: '手数料率(手数料)を入力してください',
  proxyproxy18: 'XX%以下',
  proxyproxy19: '手数料率(利息率)',
  proxyproxy20: '手数料率(利息率)を入力してください',
  proxyproxy21: 'XX%以下',
  proxyproxy22: 'エージェントID',
  proxyproxy23: '上級エージェントID',
  proxyproxy24: '代理タイプ',
  proxyproxy25: 'チャネル代理',
  proxyproxy26: '代理レベル',
  proxyproxy27: '手数料率(手数料)',
  proxyproxy28: '手数料率(利息率)',
  proxyproxy29: 'Wallet Balance(MEQ)',
  proxyproxy30: '現金口座残高(MEQ)',
  proxyproxy31: '登録時刻',
  proxyproxy32: '操作する',
  proxyproxy33: '修正する',
  proxyproxy34: 'キャンセル',
  proxyproxy35: 'ユーザーを招待',
  proxyproxy36: '確認する',
  proxyproxy37: '合計 {n} 件',
  proxyproxy38: '{n} 件/ページ',
  proxyproxy39: '{n} ページに移動',
  proxyproxy40: '業績報告書',
  proxyproxy41: '氏名/エージェントID',
  proxyproxy42: '名前またはエージェントIDを入力してください',
  proxyproxy43: '検索',
  proxyproxy44: 'エクスポート',
  proxyproxy45: '氏名',
  proxyproxy46: 'エージェントID',
  proxyproxy47: '上位エージェントID',
  proxyproxy48: 'ユーザー数',
  proxyproxy49: '総入金額(MEQ)',
  proxyproxy50: '総引き出し額(MEQ)',
  proxyproxy51: '取引金額({n})',
  proxyproxy52: 'コミッション額({n})',
  proxyproxy53: '資金使用料({n})',
  proxyproxy54: '合計 x 件',
  proxyproxy55: '{n} 件/ページ',
  proxyproxy56: 'x ページに移動',
  proxyproxy57: 'すべてのユーザーは招待により直属ユーザーを増やし、代理レベルは条件に応じて自動昇格します。',
  proxyproxy58: '昇格条件を満たすと、ユーザーは三級代理、二級代理、一級代理の順に昇格します。',
  proxyproxy59: '代理コミッションはプラットフォーム規則および実際の取引データに基づき精算されます。',
  proxyproxy60: '代理の作成が完了しました',
  proxyproxy61: '代理情報を更新しました',
  proxyproxy62: '有効な比率を入力してください',
  proxycust1: '日本語',
  proxycust2: 'ログアウト',
  proxycust3: 'ユーザー管理',
  proxycust4: '氏名/ユーザーID',
  proxycust5: '入力してください',
  proxycust6: 'ステータス',
  proxycust7: 'すべて',
  proxycust8: '審査通過',
  proxycust9: '審査不合格',
  proxycust10: '検索',
  proxycust11: 'エクスポート',
  proxycust12: '顧客を作成',
  proxycust13: '氏名',
  proxycust14: '顧客名を入力してください',
  proxycust15: 'ユーザーID',
  proxycust16: 'ログインパスワード',
  proxycust17: '数字と英文字の組み合わせを使用し、8から16文字まで',
  proxycust18: 'レバレッジ比率',
  proxycust19: 'レバレッジ比率を入力してください',
  proxycust20: '資金調達倍率',
  proxycust21: '資金調達倍率を入力してください',
  proxycust22: 'キャンセル',
  proxycust23: '顧客を作成',
  proxycust24: '氏名',
  proxycust25: 'ユーザーID',
  proxycust26: '取引口座',
  proxycust27: 'レバレッジ比率',
  proxycust28: '資金調達倍率',
  proxycust29: '現金口座残高(MEQ)',
  proxycust30: '取引口座残高(MEQ)',
  proxycust31: '初回入金時刻',
  proxycust32: '登録時間',
  proxycust33: 'ステータス',
  proxycust34: '操作する',
  proxycust35: '承認',
  proxycust36: '詳細',
  proxycust37: '合格',
  proxycust38: '失敗',
  proxycust39: '審査備考',
  proxycust40: '承認意見を入力してください',
  proxycust41: '閉じる',
  proxycust42: 'キャンセル',
  proxycust43: '確認する',
  proxycust44: '身分情報',
  proxycust45: '身分証明書の表面',
  proxycust46: '身分証明書の裏面',
  proxycust47: '合計 x 件',
  proxycust48: 'x 件/ページ',
  proxycust49: 'x ページに移動',
  proxycust50: '取引手数料報告',
  proxycust51: '氏名/取引口座',
  proxycust52: '名前 / 取引口座を入力してください',
  proxycust53: '取引口座',
  proxycust54: 'DT',
  proxycust55: 'LTT',
  proxycust56: '実行時間',
  proxycust57: '検索',
  proxycust58: 'エクスポート',
  proxycust59: '氏名',
  proxycust60: '取引口座',
  proxycust61: '取引口座のタイプ',
  proxycust62: '取引手数料($)',
  proxycust63: '注文番号',
  proxycust64: '実行時間',
  proxycust65: '合計 x 件',
  proxycust66: 'x 件/ページ',
  proxycust67: 'x ページに移動',
  proxycust68: 'デイトレード報告',
  proxycust69: '取引成立時間',
  proxycust70: '新規取引/決済',
  proxycust71: '新規取引',
  proxycust72: '決済',
  proxycust73: '買う/売る',
  proxycust74: '買う',
  proxycust75: '売る',
  proxycust76: 'すべて',
  proxycust77: '取引銘柄',
  proxycust78: '取引銘柄を入力してください',
  proxycust79: '氏名/取引口座',
  proxycust80: '名前 / 取引口座を入力してください',
  proxycust81: '検索',
  proxycust82: 'エクスポート',
  proxycust83: '総損益($)',
  proxycust84: '氏名',
  proxycust85: '取引口座',
  proxycust86: '注文ID',
  proxycust87: '取引銘柄',
  proxycust88: '価格',
  proxycust89: '新規取引/決済',
  proxycust90: '買う/売る',
  proxycust91: '取引量',
  proxycust92: '手数料($)',
  proxycust93: '利益と損失',
  proxycust94: '取引成立時間',
  proxycust95: '合計 x 件',
  proxycust96: 'x 件/ページ',
  proxycust97: 'x ページに移動',
  proxycust98: '長期トレード報告',
  proxycust99: '取引成立時間',
  proxycust100: '新規取引/決済',
  proxycust101: '新規取引',
  proxycust102: '決済',
  proxycust103: '買う/売る',
  proxycust104: '買う',
  proxycust105: '売る',
  proxycust106: 'すべて',
  proxycust107: '取引銘柄',
  proxycust108: '取引銘柄を入力してください',
  proxycust109: '氏名/取引口座',
  proxycust110: '名前または取引アカウントIDを入力してください',
  proxycust111: '検索',
  proxycust112: 'エクスポート',
  proxycust113: '総損益($)',
  proxycust114: '氏名',
  proxycust115: '取引口座',
  proxycust116: '注文ID',
  proxycust117: '取引銘柄',
  proxycust118: '価格',
  proxycust119: '新規取引/決済',
  proxycust120: '買う/売る',
  proxycust121: '取引量',
  proxycust122: '利息($)',
  proxycust123: '利益と損失',
  proxycust124: '取引成立時間',
  proxycust125: '合計 x 件',
  proxycust126: 'x 件/ページ',
  proxycust127: 'x ページに移動',
  proxycust128: '名前またはユーザーIDまたは取引口座',
  proxymoneymanage1: '日本語',
  proxymoneymanage2: 'ログアウト',
  proxymoneymanage3: '資金管理',
  proxymoneymanage4: '取引口座資金移動報告',
  proxymoneymanage5: '氏名/取引口座',
  proxymoneymanage6: '名前/取引アカウントIDを入力してください',
  proxymoneymanage7: '資金移動の種類',
  proxymoneymanage8: 'すべて',
  proxymoneymanage9: '入金',
  proxymoneymanage10: '出金',
  proxymoneymanage11: '資金移動時間',
  proxymoneymanage12: '検索',
  proxymoneymanage13: 'エクスポート',
  proxymoneymanage14: '注文番号',
  proxymoneymanage15: '氏名',
  proxymoneymanage16: '取引口座',
  proxymoneymanage17: '資金移動金額($)',
  proxymoneymanage18: '資金移動金額',
  proxymoneymanage19: '為替レート',
  proxymoneymanage20: '資金移動の種類',
  proxymoneymanage21: '資金移動時間',
  proxymoneymanage22: '合計 x 件',
  proxymoneymanage23: 'x 件/ページ',
  proxymoneymanage24: 'x ページに移動',
  proxymoneymanage25: '手数料報告',
  proxymoneymanage26: '氏名/ユーザーID/取引口座',
  proxymoneymanage27: '入力してください',
  proxymoneymanage28: 'アカウントタイプ',
  proxymoneymanage29: 'すべて',
  proxymoneymanage30: 'DT',
  proxymoneymanage31: 'LTT',
  proxymoneymanage32: '取引成立時間',
  proxymoneymanage33: '検索',
  proxymoneymanage34: 'エクスポート',
  proxymoneymanage35: '氏名',
  proxymoneymanage36: 'エージェントID',
  proxymoneymanage37: 'エージェントレベル',
  proxymoneymanage38: 'アカウントタイプ',
  proxymoneymanage39: '手数料率(手数料)',
  proxymoneymanage40: '取引手数料(MEQ)',
  proxymoneymanage41: '取引手数料',
  proxymoneymanage42: '為替レート',
  proxymoneymanage43: '手数料(MEQ)',
  proxymoneymanage44: 'ユーザーID',
  proxymoneymanage45: '取引口座',
  proxymoneymanage46: 'シンボル',
  proxymoneymanage47: '取引量',
  proxymoneymanage48: '価格',
  proxymoneymanage49: '新規取引/決済',
  proxymoneymanage50: '新規取引',
  proxymoneymanage51: '決済',
  proxymoneymanage52: '買う/売る',
  proxymoneymanage53: '買う',
  proxymoneymanage54: '売る',
  proxymoneymanage55: '注文番号',
  proxymoneymanage56: '取引成立時間',
  proxymoneymanage57: '合計 x 件',
  proxymoneymanage58: 'x 件/ページ',
  proxymoneymanage59: 'x ページに移動',
  proxymoneymanage60: '振込金額(MEQ)',
  proxymoneymanage61: '振込金額({n})',
  proxymoneymanage62: '名前またはIDまたは取引口座ID',
  proxymoneymanage63: 'アカウントタイプ',
  proxymoneymanage64: 'デイトレード口座',
  proxymoneymanage65: '信用取引口座',
  user1: '日本語',
  user2: 'ログアウト',
  user3: '登録',
  user4: 'ユーザー名を入力してください',
  user5: 'ユーザーID',
  user6: '8-16桁の英数字パスワードを入力してください"',
  user7: 'パスワードの確認',
  user8: 'メールアドレスを入力してください(任意)',
  user9: '電話番号を入力してください(任意)',
  user10: '招待コード',
  user11: '登録',
  user12: 'すでにアカウントをお持ちですか？ログイン',
  user13: 'そのユーザー名はすでに存在しています。別のユーザー名を入力してください',
  user14: 'パスワードが要件に合いません。8から16桁の英数字パスワードを入力してください',
  user15: 'パスワード確認の入力エラー',
  user16: '誤った電子メール確認コードです',
  user17: 'サインアップすることで、利用規約およびプライバシーポリシーに同意するものとします',
  user18: '手動認証',
  user19: '画像上の文字を順番にクリックしてください',
  user20: '再読み込み',
  user21: '認証を送信',
  user22: '認証に失敗しました。もう一度お試しください。',
  user23: '登録',
  user24: 'ユーザー名/ユーザーIDを入力してください',
  user25: 'パスワードを入力してください',
  user26: 'ログイン',
  user27: 'ホーム',
  user28: 'アカウント情報',
  user29: '入金',
  user30: '出金',
  user31: '資金移動',
  user32: '現金口座残高(MEQ)',
  user33: '総資産',
  user34: '総資産 = 現金口座残高 + デイトレード口座権益 + 信用取引口座権益',
  user35: '取引アカウント情報',
  user36: '取引口座',
  user37: '取引アカウントのパスワード',
  user38: 'コピー',
  user39: '取引口座概要',
  user40: '取引口座への入金',
  user41: '取引口座からの出金',
  user42: '取引口座ID',
  user43: 'レバレッジ比率',
  user44: '口座純資産(MEQ)',
  user45: 'LTT',
  user46: '信用倍率',
  user47: '{n}倍',
  user48: '口座残高($)',
  user49: 'マイプロフィール',
  user50: 'ユーザー名',
  user51: 'ユーザーID',
  user52: '取引口座',
  user53: '登録時刻',
  user54: '電子メール',
  user55: 'ログインパスワード',
  user56: '携帯電話番号',
  user57: '身分情報',
  user58: '身分証明書の表面',
  user59: '身分証明書の裏面',
  user60: '銀行情報',
  user61: '口座名義人',
  user62: '銀行名',
  user63: '銀行カードの口座番号',
  user64: '身分情報の補完',
  user65: '未入力',
  user66: '口座名義人の氏名を入力してください',
  user67: '銀行名を入力してください',
  user68: '銀行カード番号を入力してください',
  user69: '支店名を入力してください',
  user70: 'キャンセル',
  user71: '確認する',
  user72: 'ユーザー名を変更する',
  user73: '元のユーザー名',
  user74: '新しいユーザー名を入力してください',
  user75: '携帯番号を変更する',
  user76: '旧携帯番号',
  user77: '新しい携帯番号を入力してください',
  user78: 'メールアドレスの変更',
  user79: '旧メールアドレス',
  user80: '新しいメールアドレスを入力してください',
  user81: 'パスワードを再設定する',
  user82: '古いパスワードを入力してください',
  user83: '新しいパスワードを入力してください',
  user84: '提出する',
  user85: '携帯電話番号の変更',
  user86: '銀行カード情報を変更する',
  user87: '通知',
  user88: '資金移動が成功しました',
  user89: '入金成功',
  user90: '出金成功',
  user91: 'パスワードをお忘れですか？',
  user92: '新しいパスワードを入力してください(8～16文字の英字+数字)',
  user93: 'メール認証コードを入力してください',
  user94: '認証コードを取得する',
  user95: '確認コードを再度取得する',
  user96: '間違った認証コード',
  user97: '戻る ログイン',
  user98: 'ユーザー名/ユーザーIDを入力してください',
  user99: '確認パスワードを入力してください',
  user100: '招待コードを入力してください(必須ではありません)',
  user101: '読み、受け入れる',
  user102: 'サービス規約',
  user103: 'そして',
  user104: 'プライバシーポリシー',
  user105: 'パスワードを再設定する',
  user106: '取引口座ID',
  user107: '取引口座パスワード',
  user108: '取引口座へ振替',
  user109: '現金口座へ振替',
  user110: '取引パスワードがリセットされました',
  user111: 'ログインパスワードを入力してください',
  user112: '取引パスワードを確認',
  user113: 'USDTウォレットアドレス',
  user114: 'ログインパスワードを入力してください',
  user115: '振替方向',
  user116: 'ログインパスワードを入力して認証してください',
  user117: '振替可能額',
  user118: '受取人ユーザー名',
  user119: '振替ルール',
  user120: '受取人ユーザー名が実際の受取人と一致していることを確認してください。一致しない場合は、受取人IDを確認してから送金してください。',
  user121: '送金は送信後すぐに有効になります。慎重に操作してください。',
  user122: '口座、方向、金額を確認してから送信してください',
  user123: '取引口座残高が不足しています',
  user124: '現金口座残高が不足しています',
  user125: '正しい出金金額を入力してください',
  usermoney1: '日本語',
  usermoney2: 'ログアウト',
  usermoney3: '資金管理',
  usermoney4: '入金',
  usermoney5: '入金報告',
  usermoney6: '現金口座(MEQ)',
  usermoney7: '$',
  usermoney8: '入金額',
  usermoney9: '為替レート',
  usermoney10: '入金額',
  usermoney11: '入金受領書',
  usermoney12: '入金額を入力してください',
  usermoney13: '入金受領書の情報を入力してください',
  usermoney14: '財布',
  usermoney15: '送金額',
  usermoney16: '送金銀行',
  usermoney17: '口座名義人',
  usermoney18: '銀行名',
  usermoney19: '銀行カードの口座番号',
  usermoney20: '提出する',
  usermoney21: '入金注文の送信が成功しました',
  usermoney22: '注文は1〜2営業日以内に審査が完了します',
  usermoney23: '確認する',
  usermoney24: '資金移動が成功しました',
  usermoney25: '資金移動',
  usermoney26: '資金移動報告',
  usermoney27: '資金移動の種類',
  usermoney28: '取引口座資金移動',
  usermoney29: '代理人への送金',
  usermoney30: '振替操作',
  usermoney31: '取引口座への転送',
  usermoney32: '現金口座に振り替える',
  usermoney33: '受取代理店ID',
  usermoney34: '代理IDを入力してください',
  usermoney35: '受取人ユーザー名',
  usermoney36: '取引口座',
  usermoney37: 'DT',
  usermoney38: 'LTT',
  usermoney39: '$',
  usermoney40: '現金口座残高',
  usermoney41: '取引口座残高',
  usermoney42: '資金移動金額',
  usermoney43: '資金移動の金額を入力してください',
  usermoney44: '提出する',
  usermoney45: '資金移動成功',
  usermoney46: '確認する',
  usermoney47: '出金',
  usermoney48: '出金報告',
  usermoney49: '現金口座残高',
  usermoney50: '$',
  usermoney51: '出金額',
  usermoney52: '引き出し金額を入力してください',
  usermoney53: '為替レート',
  usermoney54: '出金額',
  usermoney55: '受取銀行',
  usermoney56: '出金申請が正常に提出されました',
  usermoney57: '注文は1〜2営業日以内に審査が完了します',
  usermoney58: '確認する',
  usermoney59: 'リマインダー',
  usermoney60: 'まだ銀行カード情報が認証されていません。出金する前に銀行カード情報を完了してください。',
  usermoney61: 'キャンセル',
  usermoney62: '即時完了',
  usermoney63: '提出する',
  usermoney64: 'Net P/L',
  usermoney65: 'USDTアドレス',
  usermoney66: '钱包二维码',
  usermoney67: '元股介绍',
  usermoney68: 'HeyMeta の基軸通貨は Meta Equity(MEQ)です。MEQ は Tether(USDT)と 1:1 で連動し、入金、送金、取引口座への振替、エコシステム権利の決済に利用できます。',
  usermoney69: '損益',
  usermoney70: 'MEQ は USDT と 1:1 で連動しています',
  usermoney71: '入金、送金、取引口座への振替に利用できます',
  usermoney72: '金額はシステムのリアルタイム為替レートに準じます',
  usermoney73: 'ウォレットネットワークとアドレスを確認してください',
  usermoney74: 'チェーン上の反映時間はネットワーク承認状況に準じます',
  usermoney75: 'プラットフォームがニーモニックや秘密鍵を求めることはありません',
  usermoney76: 'アカウント情報を第三者に開示しないでください',
  usermoney77: '完了した振替は資金履歴で確認できます',
  usermoney78: '送信後のトランザクションハッシュは変更できません',
  usermoney79: 'ご不明な点はオンラインサポートへお問い合わせください',
  usermoney80: 'セキュリティのお知らせ',
  userstatement1: '日本語',
  userstatement2: 'ログアウト',
  userstatement3: 'レポート管理',
  userstatement4: '入金報告',
  userstatement5: '資金移動の種類',
  userstatement6: 'すべて',
  userstatement7: '銀行カード入金',
  userstatement8: '取引口座資金移動',
  userstatement9: 'ステータス',
  userstatement10: 'すべて',
  userstatement11: '審査待ち',
  userstatement12: '審査通過',
  userstatement13: '審査不合格',
  userstatement14: '入金時間',
  userstatement15: '検索',
  userstatement16: 'エクスポート',
  userstatement17: '注文番号',
  userstatement18: '入金額',
  userstatement19: '入金額($)',
  userstatement20: '為替レート',
  userstatement21: '現金口座残高',
  userstatement22: '実際入金',
  userstatement23: '資金移動の種類',
  userstatement24: '入金時間',
  userstatement25: '入金受領書',
  userstatement26: '入金番号',
  userstatement27: '備考',
  userstatement28: 'ステータス',
  userstatement29: '操作する',
  userstatement30: '詳細',
  userstatement31: '閉じる',
  userstatement32: '合計 x 件',
  userstatement33: 'x 件/ページ',
  userstatement34: 'x ページに移動',
  userstatement35: '出金報告',
  userstatement36: 'ステータス',
  userstatement37: 'すべて',
  userstatement38: '審査待ち',
  userstatement39: '審査通過',
  userstatement40: '審査不合格',
  userstatement41: '出金時間',
  userstatement42: '検索',
  userstatement43: '注文番号',
  userstatement44: '出金額',
  userstatement45: '出金額',
  userstatement46: '為替レート',
  userstatement47: '現金口座残高',
  userstatement48: '出金時間',
  userstatement49: '備考',
  userstatement50: 'ステータス',
  userstatement51: '操作する',
  userstatement52: '詳細',
  userstatement53: 'ステータス',
  userstatement54: '閉じる',
  userstatement55: '合計 x 件',
  userstatement56: 'x 件/ページ',
  userstatement57: 'x ページに移動',
  userstatement58: '取引口座振替記録',
  userstatement59: '取引口座',
  userstatement60: '取引口座',
  userstatement61: 'デイトレード',
  userstatement62: '長期トレード',
  userstatement63: '資金移動時間',
  userstatement64: '検索',
  userstatement65: '注文番号',
  userstatement66: '資金移動金額($)',
  userstatement67: '資金移動金額',
  userstatement68: '為替レート',
  userstatement69: '取引口座',
  userstatement70: '取引口座残高',
  userstatement71: '資金移動時間',
  userstatement72: '合計 x 件',
  userstatement73: 'x 件/ページ',
  userstatement74: 'x ページに移動',
  userstatement75: 'エージェント資金移動報告',
  userstatement76: '資金移動の種類',
  userstatement77: 'すべて',
  userstatement78: '振り込み',
  userstatement79: '引き出し',
  userstatement80: '資金移動の時間',
  userstatement81: '検索',
  userstatement82: '注文番号',
  userstatement83: 'エージェントID',
  userstatement84: '受取人IDを入力してください',
  userstatement85: '資金移動金額($)',
  userstatement86: '現金口座残高',
  userstatement87: '資金移動の種類',
  userstatement88: '資金移動の時間',
  userstatement89: '合計 x 件',
  userstatement90: 'x 件/ページ',
  userstatement91: 'x ページに移動',
  userstatement92: 'デイトレード報告',
  userstatement93: '取引成立時間',
  userstatement94: '新規取引/決済',
  userstatement95: '新規取引',
  userstatement96: '決済',
  userstatement97: '買う/売る',
  userstatement98: '買う',
  userstatement99: '売る',
  userstatement100: 'すべて',
  userstatement101: 'コード',
  userstatement102: '証券コードを入力してください',
  userstatement103: '検索',
  userstatement104: 'エクスポート',
  userstatement105: '総損益($)',
  userstatement106: '注文ID',
  userstatement107: 'コード',
  userstatement108: '価格',
  userstatement109: '新規取引/決済',
  userstatement110: '買う/売る',
  userstatement111: '取引量',
  userstatement112: '手数料({n})',
  userstatement113: '利益と損失',
  userstatement114: '実行時間',
  userstatement115: '合計 x 件',
  userstatement116: 'x 件/ページ',
  userstatement117: 'x ページに移動',
  userstatement118: '長期トレード報告',
  userstatement119: '実行時間',
  userstatement120: '新規取引/決済',
  userstatement121: '新規取引',
  userstatement122: '決済',
  userstatement123: '買う/売る',
  userstatement124: '買う',
  userstatement125: '売る',
  userstatement126: 'すべて',
  userstatement127: 'コード',
  userstatement128: '証券コードを入力してください',
  userstatement129: '検索',
  userstatement130: 'エクスポート',
  userstatement131: '総損益($)',
  userstatement132: '注文ID',
  userstatement133: 'コード',
  userstatement134: '価格',
  userstatement135: '新規取引/決済',
  userstatement136: '買う/売る',
  userstatement137: '取引量',
  userstatement138: '利息({n})',
  userstatement139: '利益と損失',
  userstatement140: '実行時間',
  userstatement141: '合計 x 件',
  userstatement142: 'x 件/ページ',
  userstatement143: 'x ページに移動',
  public1: '資金監査',
  public2: 'エージェント出金監査',
  public3: '業績報告書',
  public4: 'ユーザー詳細',
  public5: 'マイプロフィール',
  public6: '資金管理',
  public7: '顧客管理',
  public8: '名前を入力してください',
  public9: 'ユーザー名はすでに存在します',
  public10: 'メールアドレスを入力してください',
  public11: '電子メールの形式が間違っています',
  public12: 'パスワードの長さは8文字未満にすることはできません。',
  public13: 'パスワードの長さは16文字を超えることはできません。',
  public14: '数字と文字の両方を含まなければなりません。',
  public15: 'サブエージェントが正常に作成されました。',
  public16: '変更が成功しました。',
  public17: '選んでください',
  public18: 'すべて',
  public19: '承認されました',
  public20: 'ご入力ください',
  public21: '作成が成功しました',
  public22: '開始日',
  public23: '終了日',
  public24: '選んでください',
  public25: '総手数料',
  public26: '顧客を追加',
  public27: 'コピーが成功しました',
  public28: '続ける',
  public29: '数字を入力してください',
  public30: '最低入金額は10ドルです',
  public31: 'SWIFTコードを入力してください',
  public32: '審査失敗',
  public33: '資料をアップロード',
  public34: '審査待ち',
  public35: '審査済み',
  public36: '審査失敗',
  public37: '銀行カード情報が認証されていません。銀行カード情報を入力してから再度入金してください。',
  public38: '為替レート',
  public39: 'パスワードを忘れました',
  public40: '認証コードを送信する',
  public41: '認証コードを入力してください',
  public42: 'アカウントがありません？',
  public43: '携帯電話番号を入力してください(必須ではありません)',
  public44: '招待コード(任意)',
  public45: 'アカウントをお持ちですか？',
  public46: '右にスワイプ',
  public47: '電話番号を入力してください',
  public48: 'もう一度パスワードを入力してください',
  public49: 'パスワードが一致しません！',
  public50: '取引パスワードをリセットする',
  public51: '取引口座残高',
  public52: '為替レート',
  public53: '身分証明書の変更',
  public54: '身分証明書の表面をアップロードしてください',
  public55: '身分証明書の裏面をアップロードしてください',
  public56: '認証情報が提出されました',
  public57: '送信が成功しました',
  public58: 'メールを変更する',
  public59: '新しいメールアドレスを入力してください',
  public60: '認証を提出する',
  public61: '銀行カード番号を入力してください',
  public62: '認証情報が送信されました',
  public63: 'アップロードされた画像のサイズは2MBを超えることはできません',
  public64: 'アップロード',
  public65: 'やることリスト',
  public66: '代理入金の審査待ち',
  public67: 'ユーザーの入金審査待ち',
  public68: '代理出金の審査待ち',
  public69: 'ユーザーの出金待ち審査',
  public70: 'ユーザー情報の審査待ち',
  public71: '金額(＄)',
  public72: '取引口座ID',
  public73: 'ログイン',
  public74: '比率が正常に変更されました',
  public75: '銀行情報が正常に変更されました',
  public76: 'パスワードが正常に変更されました',
  public77: '登録',
  public78: 'ユーザー名またはIDが存在しません',
  public79: '取引口座ID',
  public80: 'Long-Term Trade (LTT)',
  public81: 'MEQ / USDT 為替レート',
  public82: '種類',
  public83: '件名',
  public84: '時間',
  public85: 'システム通知',
  public86: '資金通知',
  public87: '取引通知',
  public88: 'キャンペーン通知',
  public89: '既読',
  public90: '未読',
  text1: 'Meta Equity(MEQ)',
  text2: 'Transaction Hash',
  text3: 'USDT数量を入力してください',
  text4: 'メール認証コード',
  text5: '出金USDTアドレスを入力してください',
  text6: 'ボーナスレポート',
  text7: 'リスク補填ボーナスを受け取る',
  text8: 'リスク補填ボーナスを使用する',
  text9: '総ボーナス(MEQ-A)',
  text10: '現在のボーナス残高(MEQ-A)',
  text11: '未受取ボーナス(MEQ-A)',
  text12: '手動で受け取る',
  text13: '自動受取',
  text14: '取引番号',
  text15: '総資産(MEQ)',
  text16: 'ボーナス金額(MEQ-A)',
  text17: '受け取り比率',
  text18: '現在のボーナス残高(MEQ-A)',
  text19: '配布時間',
  text20: '受け取り時間',
  text21: 'リスク補填受け取り方法',
  text22: '使用済みボーナス(MEQ-A)',
  text23: '補填可能ボーナス(MEQ-A)',
  text24: 'ボーナスを使用',
  text25: '取引番号',
  text26: '補填ボーナス金額(MEQ-A)',
  text27: '現在のボーナス残高(MEQ-A)',
  text28: '現在の現金口座残高(MEQ)',
  text29: '生成時間',
  text30: '使用時間',
  text31: '説明',
  text32: '1. 受取資格：',
  text33: '(1)登録を完了し、プラットフォーム規則を満たすユーザーはボーナス・インセンティブプログラムに参加できます；',
  text34: '(2)ボーナスは口座資産、入金状況、キャンペーン規則およびシステム記録に基づき計算・配布されます；',
  text35: '(3)計算方法、比率および配布時間はプラットフォーム公告とシステム記録に準じます；',
  text36: '(4)ボーナスは権利枠またはリスク緩衝ツールとしてのみ使用され、出金可能資金ではありません。',
  text37: '(5)ユーザーは毎週手動で新コインを受け取ることができ、一度に複数の新コインを受け取ることも可能です。また、自動受け取りを設定することもできます。',
  text38: '2. 使用規則：',
  text39: '1)信用アカウント内の新コインは、取引の損失額を補填するために使用されます；',
  text40: '(2)信用アカウント内の新コインの残高が取引の損失額を下回る場合、まず信用アカウント内の残高を使用し、残りの損失額は次回に繰り越されます。',
  text41: '未使用',
  text42: '使用済み',
  text43: '自動受け取り',
  text44: '手動受け取り',
  text45: 'リスク補償概要',
  text46: 'リスク補償受取履歴',
  text47: 'リスク補償相殺履歴',
  text48: 'リスク補償コミッション明細',
  text49: '受け取り時間',
  text50: '受け取り方法',
  text51: '上位代理店',
  text52: '計算時間',
  text53: 'リスク補填総額',
  text54: '使用したリスク補填額',
  text55: '総使用リスク補填額',
  text56: 'リスク補填コミッション割合(%)',
  text57: 'コミッション(MEQ)',
  text58: '総コミッション額',
  text59: 'ウォレットアドレス',
  text60: 'ウォレットタイプ',
  text61: 'ニーモニックを変更',
  text62: '初期ニーモニックが生成されました：',
  text63: 'ニーモニック',
  text64: 'ニーモニックを入力してください',
  text65: '英字または数字を入力してください',
  text66: '受け取る',
  text67: 'MEQ',
  text68: 'もっと見る',
  text69: '<h3>1. HeyMeta ボーナス・インセンティブプログラムとは</h3>\n<p>HeyMeta ボーナス・インセンティブプログラムは、デイリー成長ボーナス(MEQ-P)とリスク補填ボーナス(MEQ-A)で構成され、長期的なインセンティブと取引リスクの緩衝を目的としています。</p>\n<p>登録、入金、取引などの実際の利用行動に応じて、ユーザーはプラットフォーム規則に基づき MEQ-P を累積できます。所定の有効化条件を満たすと、MEQ-P は取引損失の補填に利用できる MEQ-A に転換されます。</p>\n<h3>2. 参加方法</h3>\n<p><strong>① アカウント登録</strong>：登録完了後、システムはデイリー成長ボーナス(MEQ-P)の記録と累積を開始します。</p>\n<p><strong>② 入金を行う</strong>：条件を満たす入金により、有効化対象額がリスク補填ボーナス(MEQ-A)へ転換されます。</p>\n<p><strong>③ アカウントを継続利用する</strong>：取引およびエコシステムへの参加を継続することで、より多くのプラットフォーム権益の獲得につながります。</p>\n<h3>3. ボーナスの用途</h3>\n<p>MEQ-A は規則に合致する取引損失の補填にのみ自動適用されます。出金、譲渡、取引元本としての使用はできません。</p>\n<p>MEQ-P は未有効化の権利であり資金属性を持たず、プラットフォーム規則を満たした場合にのみ有効化されます。</p>\n<h3>4. リスク提示</h3>\n<p>すべての取引にはリスクがあります。ボーナスはリスク緩衝ツールであり、収益または元本を保証するものではありません。</p>\n<p>プラットフォームはリスク管理規則に基づき異常行為を識別し、関連権益を調整、凍結、または回収する権利を有します。</p>',
  text70: 'ボーナス・インセンティブルール',
  text71: 'MEQ報酬ランキング Top',
  text72: '入金額(MEQ)',
  text73: '入金後純資産',
  text74: '報酬割合',
  text75: '日数',
  text76: '報酬額(MEQ-A)',
  text77: '受取日',
  text78: '報酬基準額',
  text79: '付与ボーナス額(MEQ-P)',
  text80: '報酬MEQ',
  text81: '現在の報酬基準額',
  text82: '残りのデイリー成長ボーナス(MEQ-P)',
  text83: '累計デイリー成長ボーナス(MEQ-P)',
  text183: '有効化可能な成長ボーナス（MEQ-P）',
  text84: '累計獲得MEQ',
  text85: '有効化済みリスク補填ボーナス(MEQ-A)',
  text185: '有効化済みボーナス（MEQ-A）',
  text86: '有効化金額(MEQ-A)',
  text87: '勘定科目を取り戻すための唯一の証憑である次の助数詞を大切に保管してください。漏洩や紛失しないでください。',
  text88: '必要に応じて、後でアカウントの管理とリカバリを容易にするために、覚えやすい助数詞に変更することもできます。',
  text89: 'ニーモニックフレーズの変更は一度限りです。',
  text90: '10～12文字の英数字で構成する必要があります。',
  text91: '新しいニーモニックフレーズは次のとおりです：',
  text92: 'ニーモニックフレーズは大切に保管してください。パスワードを忘れた場合は、ニーモニックフレーズを使ってアカウントを復元できます。',
  text93: 'ご注意：パスワードとニーモニックフレーズの両方を忘れた場合、アカウントを復元することはできません。',
  text94: '助記詞の修正に成功しました',
  text95: '贈与金タイプ',
  text96: '贈与金の保管',
  text97: '贈与金の有効化',
  text98: 'デイリー成長ボーナス',
  text99: '成長ボーナス概要',
  text100: '成長ボーナス受取履歴',
  text101: '成長ボーナス有効化履歴',
  text102: 'アクティベーション記録',
  text103: '累計デイリー成長ボーナス(MEQ-P)',
  text104: '累計獲得MEQ',
  text105: '日付',
  text106: '有効化済みリスク補填ボーナス(MEQ-A)',
  text107: '金額',
  text108: '走馬灯記録',
  text109: 'アクティブ化日',
  text110: '配当率',
  text111: '配当金額',
  text112: '現金口座への入金',
  text113: '現在保有株式数',
  text114: '累計受取配当',
  text115: '配当',
  text116: '配当記録',
  text117: '配布時間',
  text319: 'リスク補填ボーナス規則(MEQ-A)',
  text320: '1. 定義',
  text321: '2. 取得方法',
  text322: '3. 利用ルール',
  text323: '4. 利用制限',
  text324: '5. リスク提示',
  text325: '6. リスク管理と違反対応',
  text326: '7. 規則変更および最終解釈権',
  text133: 'リスク補填ボーナス(Active Meta Equity、以下「MEQ-A」)とは、有効化済みの権利枠を指します。特定条件下で取引損失の補填にのみ利用でき、ユーザーが自由に処分できる資金ではありません。',
  text134: 'ユーザーは以下の方法でMEQ-Aを取得できます：',
  text135: '1. 未有効化エクイティからの転換。',
  text136: '2. 口座残高報酬。プラットフォームはユーザーの総資産および関連ルールに基づき、日次でMEQ-Aを算出・付与します。計算式：',
  text137: 'MEQ-A = 総資産 × 報酬率',
  text139: '1. MEQ-Aはプラットフォーム上の取引損失の補填にのみ使用されます。',
  text140: '2. MEQ-Aは損失発生時にシステムにより自動適用され、手動操作はできません。',
  text141: '3. MEQ-Aは新規建玉、ポジション追加、または証拠金として使用できません。',
  text142: 'MEQ-Aはプロモーションクレジットであり資金属性を持たず、以下の制限が適用されます：',
  text143: '1. 出金・譲渡・換金不可；',
  text144: '2. 取引元本として使用不可、利益分配対象外；',
  text145: '3. ユーザー資産またはプラットフォーム負債には該当しません；',
  text146: '4. 利息やいかなる収益も発生しません；',
  text147: '5. 利益または元本保証を意味するものではありません。',
  text148: '1. ユーザーは、MEQ-Aがリスク軽減目的のみであり、収益保証ではないことを理解し同意します。',
  text149: '2. すべての取引にはリスクが伴い、ユーザーは自己判断で損失を負担するものとします。',
  text150: '3. 法令に別段の定めがある場合を除き、取引損失についてプラットフォームは責任を負いません。',
  text151: '1. アービトラージ、リスク補填不正取得、ヘッジ取引等の異常行為が確認された場合、プラットフォームは以下の措置を講じる権利を有します：',
  text152: '(1)MEQ-Aの凍結または回収；',
  text153: '(2)参加資格の取消し；',
  text154: '(3)責任の追及。',
  text155: '2. プラットフォームは異常アカウントを審査し、必要な制限措置を講じる権利を有します。',
  text156: '1. プラットフォームは取得方法・利用ルール等を変更する権利を有します。',
  text157: '2. 関連する調整は公告により公表され、公告日から効力を生じます。',
  text158: '3. 法令で認められる範囲において、本規則の最終解釈権はプラットフォームに帰属します。',
  text329: 'デイリー成長ボーナス規則(MEQ-P)',
  text330: '1. 定義',
  text331: '2. 配布ルール',
  text332: '3. 権利の性質',
  text333: '4. 有効化メカニズム',
  text334: '5. 失効および処理',
  text335: '6. 規則変更',
  text233: 'デイリー成長ボーナス(Pending Meta Equity、以下「MEQ-P」)とは、プラットフォーム規則に基づき付与される未有効化の権利枠であり、ユーザー資産または出金可能資金ではありません。',
  text234: '1. ユーザーは登録完了時点で本活動に参加したものとみなされます。',
  text235: '2. プラットフォームは基準および報酬率に基づき、日次でMEQ-Pを付与します。',
  text236: '3. MEQ-Pは日単位で付与され、時間および割合はシステム記録に準じます。',
  text237: '4. MEQ-Pは未有効のまま累積可能です。',
  text239: 'MEQ-Pは未有効化の権利枠であり資金性を持たず、以下の制限があります：',
  text240: '1. いかなる取引にも使用できません；',
  text241: '2. 取引損失の補填には使用できません；',
  text242: '3. 出金・譲渡・贈与・換金不可；',
  text243: '4. 利息や収益は発生しません；',
  text244: '5. 預金・資産・収益保証には該当しません。',
  text245: '1. 入金完了など、プラットフォームが定める有効化条件を満たすと、MEQ-Pはリスク補填ボーナス(MEQ-A)へ自動転換されます。計算式：',
  text246: '有効化可能MEQ-P =(今回入金 − 前回有効化後の総出金)× 報酬率 × 日数',
  text247: '2. 転換比率、条件および詳細ルールはプラットフォームの最新公告に準じます。',
  text248: '3. 転換完了後、対応するMEQ-Pは保持されません。',
  text249: '1. ユーザーアカウントに異常行為、違反操作、またはプラットフォーム規則違反がある場合、プラットフォームは当該MEQ-P権益を取り消しまたは削除する権利を有します。',
  text250: '2. 長期間にわたり有効化条件を満たさない場合、プラットフォームは運営規則に基づきMEQ-Pを調整または失効処理することがあります。',
  text251: 'プラットフォームは事業運営上の必要に応じて、MEQ-Pの配布基準、計算方法および有効化ルールを調整し、公告により事前に通知することがあります。',
  fundstreams1: '資金履歴',
  fundstreams2: '流水番号',
  fundstreams3: '時間',
  fundstreams4: '変動額(MEQ)',
  fundstreams5: '変動後現金口座残高(MEQ)',
  fundstreams6: '操作元',
  fundstreams7: '内容',
  fundstreams8: '口座種別',
  fundstreams9: 'ウォレット',
  fundstreams10: '現金口座',
  fundstreams11: '取引口座',
  fundstreams12: 'デイリー成長ボーナス',
  fundstreams13: 'リスク補償ボーナス',
  user126: 'ユーザーセンターのパスワードを入力してください',
  transferrecord1: '他人からの送金',
  transferrecord2: '他人への送金',
  usermenu1: 'リスク補償ボーナス',
  usermenu2: 'デイリー成長ボーナス',
  usermenu3: '資金振替履歴',
  usermenu4: '口座送金履歴',
  transferbalance1: '現金口座の利用可能残高が不足しています。送金金額を変更してください。',
  proxytransfer1: '入力した受取人ユーザーIDは存在しません。',
  walletremark1: 'ボーナスコミッション',
  walletremark2: '取引コミッション',
  walletremark3: '現金口座へ振替',
  proxybonusgroup1: 'ユーザー成長ボーナスレポート',
  proxybonusgroup2: 'ユーザーリスク補償レポート',
  usermenu5: '取引システムへ',
  promotionCenter: 'プロモーションセンター',
  membershipCenter: 'メンバーシップセンター',
  promotionInviteDisabled: '招待機能は現在無効です',
  promotionCurrentLevel: '現在のプロモーションレベル',
  promotionValidStatus: '有効ユーザーステータス',
  promotionValid: '有効',
  promotionInvalid: '有効条件未達',
  promotionAutoUpgrade: '自動昇格',
  promotionEnabled: '有効',
  promotionDisabled: '無効',
  promotionDirectCount: '直接紹介人数',
  promotionDirectValidCount: '有効な直接紹介人数',
  promotionTeamCount: 'チーム総人数',
  promotionTeamValidCount: 'チーム有効ユーザー',
  promotionInviteCode: '招待コード',
  promotionInviteLink: '招待リンク',
  promotionCopy: 'コピー',
  promotionCopyLink: 'リンクをコピー',
  promotionScanRegister: 'QRコードで登録',
  promotionNextLevel: '次のプロモーションレベル',
  promotionRemainingDirect: '必要な有効直接紹介',
  promotionRemainingTeam: '必要なチーム有効ユーザー',
  promotionTradeRatesReadonly: '取引コミッション率（閲覧のみ）',
  promotionMemberRatesReadonly: 'プレミアム会員紹介コミッション率（閲覧のみ）',
  promotionLevel3: '三級代理',
  promotionLevel2: '二級代理',
  promotionLevel1: '一級代理',
  promotionMaster: 'マスターエージェント',
  promotionNormalUser: '一般ユーザー',
  promotionPremiumMember: 'プレミアム会員',
  promotionNormalMember: '一般会員',
  promotionTeam: 'プロモーションチーム',
  promotionSearchPlaceholder: 'ユーザー名 / ユーザーID / 取引口座',
  promotionDirectInvite: '直接紹介',
  promotionAllTeam: 'チーム全体',
  promotionUserId: 'ユーザーID',
  promotionUsername: 'ユーザー名',
  promotionLevel: '代理レベル',
  promotionMemberLevel: '会員レベル',
  promotionValidUser: '有効ユーザー',
  promotionYes: 'はい',
  promotionNo: 'いいえ',
  promotionRegisterTime: '登録時間',
  promotionMyCommission: '紹介コミッション',
  promotionTradeCommission: '取引コミッション',
  promotionMemberCommission: 'プレミアム会員紹介コミッション',
  promotionTotalCommission: '累計コミッション',
  promotionTradeNo: '取引番号',
  promotionCommissionBase: 'コミッション計算基準',
  promotionDifferentialRate: '実際の差額率',
  promotionCommissionAmount: '実際のコミッション',
  promotionTime: '時間',
  promotionMemberOrder: '会員注文',
  promotionSourceUser: '紹介元ユーザー',
  promotionCopySuccess: 'コピーしました',
  promotionCopyFailed: 'コピーに失敗しました。手動でコピーしてください。',
  promotionSystemHint: '新しい代理体系が有効です。ユーザーは招待コードまたは招待リンクから登録し、代理レベルはシステムにより自動昇格します。',
  membershipDisabled: 'プレミアム会員機能は現在無効です',
  membershipCurrentLevel: '現在の会員レベル',
  membershipCashBalance: '現金口座残高',
  membershipExpireTime: '会員有効期限',
  membershipPremium: 'プレミアム会員',
  membershipDays: '日',
  membershipPermanent: '無期限',
  membershipRenew: 'プレミアム会員を更新',
  membershipUpgrade: 'プレミアム会員にアップグレード',
  membershipOrders: '購入履歴',
  membershipOrderNo: '注文番号',
  membershipPaidAmount: '支払金額(MEQ)',
  membershipPeriod: '会員期間',
  membershipPurchaseTime: '購入時間',
  membershipConfirmPurchase: '現金口座から {price} MEQ を使用してプレミアム会員を購入しますか？',
  membershipConfirmTitle: '確認',
  membershipPurchaseSuccess: '購入しました',
  promotionDirectLevel3PlusCount: '直属三級以上の代理',
  promotionDirectLevel2PlusCount: '直属二級以上の代理',
  promotionUpgradeRequirement: '昇格条件',
  promotionRequirementDirectValid: '直属の有効ユーザー',
  promotionRequirementDirectLevel3Plus: '直属三級以上の代理',
  promotionRequirementDirectLevel2Plus: '直属二級以上の代理',
  promotionCurrentCount: '現在数',
  promotionRequiredCount: '必要数',
  promotionRemainingCount: '残り',
  promotionRiskGiftCommission: 'リスクボーナス紹介コミッション',
  promotionGiftAmount: 'リスクボーナス金額',
  usermenu6: '取引を開始',
  invitationDetailsV2: '紹介明細',
  commissionDetailsV2: 'コミッション明細'
}
export default messages
